const events = [
  {
    id: 'invoice_updated',
    name: 'Invoice Updated',
  },
  {
    id: 'invoice_created',
    name: 'Invoice Created',
  },
  {
    id: 'order_updated',
    name: 'Order Updated',
  },
  {
    id: 'order_created',
    name: 'Order Created',
  },
  {
    id: 'order_item_created',
    name: 'Order Item Created',
  },
  {
    id: 'daily',
    name: 'Daily',
  },
  {
    id: 'hourly',
    name: 'Hourly',
  },
  {
    id: 'receiving',
    name: 'Receiving',
  },
];

const conditions = [
  {
    id: 'boolean',
    name: 'Is True or False',
    type: 'boolean',
  },
  {
    id: 'date',
    name: 'Has Date',
    type: 'date',
  },
  {
    id: 'itemCount',
    name: 'Has Item Count',
    type: 'item_count',
  },
  {
    id: 'text',
    name: 'Has Text',
    type: 'text',
  },
  {
    id: 'aggregateRelationship',
    name: 'Aggregate Relationship',
    type: 'aggregate_relationship',
  },
  {
    id: 'hasNotPerformedAction',
    name: 'Has Not Performed Rule',
    type: 'has_not_performed_action',
  },
  {
    id: 'hasTag',
    name: 'Has Tag',
    type: 'has_tag',
  },
  {
    id: 'orderAge',
    name: 'Order Age',
    type: 'order_age',
  },
  {
    id: 'orderStatus',
    name: 'Order Status',
    type: 'order_status',
  },
  {
    id: 'shippingMethod',
    name: 'Shipping Method',
    type: 'shipping_method',
  },
  {
    id: 'productSku',
    name: 'Product SKU',
    type: 'product_sku',
  },
  {
    id: 'orderTotal',
    name: 'Order Total',
    type: 'order_total',
  },
  {
    id: 'orderWeight',
    name: 'Order Weight',
    type: 'order_weight',
  },
  {
    id: 'approvalStatus',
    name: 'Approval Status',
    type: 'approval_status',
  },
  {
    id: 'bomItemReceived',
    name: 'BOM Item Received',
    type: 'bom_item_received',
  },
];

const actions = [
  {
    id: 'assignTag',
    name: 'Assign Tag',
    type: 'assign_tag',
  },
  {
    id: 'updateColumn',
    name: 'Update Column',
    type: 'update_column',
  },
  {
    id: 'aggregateRelationship',
    name: 'Aggregate Relationship',
    type: 'aggregate_relationship',
  },
  {
    id: 'email',
    name: 'Send Email',
    type: 'email_notification',
  },
  {
    id: 'holdOrder',
    name: 'Hold Order',
    type: 'hold_order',
  },
  {
    id: 'sendEdi855',
    name: 'Send EDI 855',
    type: 'send_edi_855',
  },
  {
    id: 'sendUnallocatedOrdersInPurgatoryEmail',
    name: 'Send UnAllocated Orders in Purgatory Email',
    type: 'send_unallocated_orders_in_purgatory_email',
  },
  {
    id: 'sendInboundShipmentEmail',
    name: 'Send Inbound Shipment Email',
    type: 'send_inbound_shipment_email',
  },
  {
    id: 'completeAssemblyOrder',
    name: 'Complete Assembly Order',
    type: 'complete_assembly_order',
  },
];

const aggregateRelations = [
  {
    id: 'items',
    name: 'Items',
    type: 'items',
    context: 'item',
  },
];

const conditionFields = [
  {
    id: 'qty_available',
    name: 'Quantity Available',
    type: 'qty_available',
  },
  {
    id: 'channel.label',
    name: 'Channel',
    type: 'channel.label',
  },
  {
    id: 'sku',
    name: 'SKU',
    type: 'sku',
  },
  {
    id: 'shipment_warehouse_group.label',
    name: 'Shipment Warehouse',
    type: 'shipment_warehouse_group.label',
  },
];

const aggregateTypes = [
  {
    id: 'avg',
    name: 'Average',
    type: 'avg',
  },
  {
    id: 'count',
    name: 'Count',
    type: 'count',
  },
  {
    id: 'sum',
    name: 'Sum',
    type: 'sum',
  },
];

const aggregateAttributes = [
  {
    id: 'qty_available',
    name: 'Quantity Available',
    type: 'qty_available',
  },
];

const updateColumnFields = [
  {
    id: 'orderStatus',
    name: 'Order Status',
    type: 'order_status',
    values: [
      {
        id: 'onHold',
        name: 'On Hold',
        type: 'on_hold',
      },
      {
        id: 'shipped',
        name: 'Shipped',
        type: 'shipped',
      },
      {
        id: 'pending',
        name: 'Pending',
        type: 'pending',
      },
    ],
  },
  {
    id: 'skipInventory',
    name: 'Skip Inventory',
    type: 'skip_inventory',
    values: [
      {
        id: 'true',
        name: 'True',
        type: '1',
      },
      {
        id: 'false',
        name: 'False',
        type: '0',
      },
    ],
  },
  {
    id: 'customFields',
    name: 'Custom Fields',
    type: 'custom_fields',
    values: [],
  },
  {
    id: 'backgroundColor',
    name: 'Background Color',
    type: 'background_color',
    values: [],
  },
];

const isTrueFalseField = [
  {
    eventType: 'order',
    values: [
      {
        id: 'sales_posted',
        name: 'Sales Posted',
        type: 'sales_posted',
      },
      {
        id: 'skip_inventory',
        name: 'Skip Inventory',
        type: 'skip_inventory',
      },
    ],
  },
  {
    eventType: 'invoice',
    values: [
      {
        id: 'is_original_po',
        name: 'Is Original PO',
        type: 'is_original_po',
      },
    ],
  },
];

const hasDateField = [
  {
    eventType: 'order',
    values: [
      {
        id: 'orderDate',
        name: 'Order Date',
        type: 'orderDate',
      },
      {
        id: 'shipDate',
        name: 'Ship Date',
        type: 'shipDate',
      },
    ],
  },
  {
    eventType: 'invoice',
    values: [
      {
        id: 'order_date',
        name: 'Order Date',
        type: 'order_date',
      },
    ],
  },
];

// hasTag relationPath is labeled as 'Field' in the html form
const hasTagRelationPath = [
  {
    eventType: 'order',
    values: [
      {
        id: 'orderItems.item',
        name: 'Order Items > Item',
        type: 'orderItems.item',
      },
    ],
  },
  {
    eventType: 'invoice',
    values: [
      {
        id: 'lineItems.item',
        name: 'Line Items > Item',
        type: 'lineItems.item',
      },
      {
        id: 'shipment_warehouse_group.label',
        name: 'Shipment Warehouse',
        type: 'shipment_warehouse_group.label',
      },
    ],
  },
];

export const AutomationRuleConfig = {
  events,
  conditions,
  actions,
  conditionFields,
  aggregateRelations,
  aggregateTypes,
  aggregateAttributes,
  updateColumnFields,
  isTrueFalseField,
  hasDateField,
  hasTagRelationPath,
};
